/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartRecommenderAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class VisualizationSmartsRecommenderAPI {
		/**
		 * @function VisualizationSmartsRecommenderAPI#setType
		 * @description Set the visualization type and recommend a new slot binding
		 * @public
		 *
		 * @param {String} type visualization type to switch to
		 * @param {Object} transactionToken
		 *
		 */
		setType() {}

		/**
		 * @function VisualizationSmartsRecommenderAPI#addColumns
		 * @description Add columns to the visualization. Recommend the best binding and assign them. If the visualiztion is not locked to a given type then the type might change
		 * @public
		 *
		 * @param {String[]} array of column ids
		 * @param {Object} transactionToken
		 *
		 */
		addDataItems() {}

		/**
		 * @deprecated Use {@link VisualizationSmartsRecommenderAPI.setType}
		 * @function VisualizationSmartsRecommenderAPI#recommendBestVisualization
		 * @description Change the type to the recommended type
		 * @public
		 *
		 * @param {Object} transactionToken
		 *
		 */
		recommendBestVisualization() {}

		/**
		 * @function VisualizationSmartsRecommenderAPI#getRecommendedVisualizations
		 * @description Get the list of recommended visualization definition APIs for the current visualization.
		 * 
		 *
		 * @param {VisDefinitionAPI[]} vizDefinitions
		 *
		 */
		getRecommendedVisualizations() {}
	}

	VisualizationSmartsRecommenderAPI.AUTO_ID = 'auto';

	return VisualizationSmartsRecommenderAPI;
});
